import { render, staticRenderFns } from "./worklist.vue?vue&type=template&id=5ed422e5&scoped=true"
import script from "./worklist.vue?vue&type=script&lang=js"
export * from "./worklist.vue?vue&type=script&lang=js"
import style0 from "./worklist.vue?vue&type=style&index=0&id=5ed422e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed422e5",
  null
  
)

export default component.exports